import React from "react";
import OperatorRequestDetails from "./OperatorRequestDetails";

const PassportDetails = () => <OperatorRequestDetails />;

export default PassportDetails;
